import React from "react";
import TextTruncate from "components/TextTruncate";
import * as styles from "../../styles.module.scss";
const DefaultItemRenderer = (item, { handleClick, index }) => (React.createElement(TextTruncate, { key: index, className: styles.itemRenderer, onClick: handleClick, text: item }));
export default DefaultItemRenderer;
